import React from "react";
import SVGInline from "svg-inline-react";
import classNames from "classnames";
const Svg = props => {
    return (React.createElement(SVGInline, { src: props.src, className: classNames(props.className, "m-inheritParentSize"), role: "presentation", alt: props.alt, style: props.style }));
};
export default Svg;
//# sourceMappingURL=Svg.js.map